/* animations */
$(function(){

    var breakpoint = $('#animatebreak').offset().top;
    var animate_node = $('.AnimateNode');
    var animate_img = $('.AnimateImg');
    animate_img.css({"position" : "relative"});

    var AnimateNode = function AnimateNode(){
        scrollTop = $(window).scrollTop();
        animate_node.each(function(){
            var node_from_top = $(this).offset().top;
            var node_distance = node_from_top - scrollTop;
            if(node_distance < breakpoint){
                $(this).removeClass('AnimateNode--toptocenter');
                $(this).removeClass('AnimateNode--righttocenter');
                $(this).removeClass('AnimateNode--downtocenter');
                $(this).removeClass('AnimateNode--lefttocenter');
                $(this).removeClass('AnimateNode--scale0to1');
                $(this).removeClass('AnimateNode--flipX');
                $(this).removeClass('AnimateNode--flipY');

                //custom
                $(this).removeClass('AnimateNode--introslide');
                $(this).removeClass('AnimateNode--imgshape');
                $(this).removeClass('AnimateNode--customcontent');
            }
        });
        animate_img.each(function(){
            var node_from_top = $(this).offset().top;
            var node_distance = node_from_top - scrollTop;
            if(node_distance < breakpoint){
                $(this).addClass('AnimateImg--active');
            }
        });
    };

    AnimateNode();
    $(window).on('scroll', function(){
        AnimateNode();
    });
});
